import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.23588 15.7361L4.26367 14.7639L9.02757 10L4.26367 5.23612L5.23588 4.26392L9.99978 9.02781L14.7637 4.26392L15.7359 5.23612L10.972 10L15.7359 14.7639L14.7637 15.7361L9.99978 10.9722L5.23588 15.7361Z",
		fill: "#393A36"
	})
});
export default SvgClose;
